import React from "react";
import { CloseIcon } from "@icons";
import { Button } from "@design-system/Button/Button";
import styles from "./DatePicker.module.scss";

export const DatePickerFooter = ({
    showActions,
    showTodayButton,
    showClear,
    onToday,
    onClear,
    onCancel,
    onApply,
}: {
    showActions: boolean;
    showTodayButton: boolean;
    showClear: boolean;
    onToday: () => void;
    onClear: () => void;
    onCancel: () => void;
    onApply: () => void;
}) => (
    <div className={styles.footer}>
        <div>
            {showTodayButton && (
                <Button
                    type="button"
                    size="sm"
                    variant="secondary"
                    onClick={onToday}
                >
                    Today
                </Button>
            )}
            {showClear && (
                <Button
                    type="button"
                    size="sm"
                    variant="secondary"
                    onClick={onClear}
                    leftIcon={<CloseIcon />}
                >
                    Clear
                </Button>
            )}
        </div>
        {showActions && (
            <div className={styles.footerActions}>
                <Button
                    type="button"
                    size="sm"
                    variant="secondary"
                    onClick={onCancel}
                >
                    Cancel
                </Button>
                <Button
                    type="button"
                    size="sm"
                    variant="primary"
                    onClick={onApply}
                >
                    Apply
                </Button>
            </div>
        )}
    </div>
);
